import { render, staticRenderFns } from "./Zupanije.vue?vue&type=template&id=2143baae&scoped=true&"
import script from "./Zupanije.vue?vue&type=script&lang=js&"
export * from "./Zupanije.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2143baae",
  null
  
)

export default component.exports